import {Observable} from "rxjs";
import {I18nService} from "./i18n.service";
import {TranslateLoader} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

export class CombinedTranslateLoader implements TranslateLoader {
    private localLoader: TranslateLoader;

    constructor(private i18nService: I18nService, private httpClient: HttpClient, prefix?: string, suffix?: string) {
        this.localLoader = new TranslateHttpLoader(httpClient, prefix, suffix);
    }

    getTranslation(language: string): Observable<any> {
        this.i18nService.loadServerTranslations(language);
        return this.localLoader.getTranslation(language);
    }
}
